import React from 'react';

import { AccountOverviewContent, AccountsGroupLoader, ErrorView } from '..';
import { useConfig } from '../../../../defaultConfig';
import { accountListSelector, useAccounts } from '../../../../fetchHooks/useAccount';
import { useCreditcards } from '../../../../fetchHooks/useCards';
import useTranslation from '../../../../hooks/useTranslation';
import mapAllAccountCardItems from '../../../EditAccountOverview/components/DragAndDropAccountsList/mapAccountCardItems';
import { NoAccountsView } from '../NoAccountsView';

export const SingleAccountsOverview = () => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    const { data: accounts, isLoading, isRefetching, ...accountState } = useAccounts({ select: accountListSelector });
    const accountNumbers = accounts?.map((account) => account.accountNumber.value) ?? [];
    const { data: cards } = useCreditcards(accountNumbers, featureToggles.enableCreditCardsFrontpage);

    if (accountState.error) {
        return <ErrorView error={accountState.error} refresh={accountState.refetch} />;
    }

    const loading = isLoading || isRefetching;

    if (loading || accounts === undefined) {
        return <AccountsGroupLoader numberOfItems={accounts?.length} />;
    }

    if (accounts.length === 0) {
        return <NoAccountsView />;
    }

    const accountCardItems = mapAllAccountCardItems(accounts, cards);

    return (
        <AccountOverviewContent
            header={translated.accountOverview.headingMobile}
            accountCardItems={accountCardItems}
            showHasMore
        />
    );
};
